<router-outlet></router-outlet>

<!-- Loading overlay global -->
@if (loadingService.isLoading$ | async) {
  <div class="loading-overlay">
    <mat-spinner diameter="48"></mat-spinner>
  </div>
}
